import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [submitStatus, setSubmitStatus] = useState<"idle" | "loading" | "success" | "error">("idle");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setSubmitStatus("loading");

    try {
      const formData = new URLSearchParams();
      formData.append("email", email);

      const response = await fetch("https://readdy.ai/api/form/d8rnum3f81iibef4bgi0", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setSubmitStatus("success");
        setEmail("");
      } else {
        setSubmitStatus("error");
      }
    } catch {
      setSubmitStatus("error");
    }
  };

  return (
    <footer className="bg-accent-900 text-foreground-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block">
              <span className="font-heading text-xl font-bold text-foreground-50">
                kakobuy<span className="text-accent-300">.courses</span>
              </span>
            </Link>
            <p className="mt-4 text-sm text-accent-200/80 leading-relaxed max-w-xs">
              Najlepszy Kakobuy Spreadsheet dla Polski. Sprawdzone linki, szybka dostawa i bezpieczne zakupy online w jednym miejscu.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-accent-200 uppercase tracking-wider mb-4">
              Newsletter
            </h4>
            <form
              onSubmit={handleSubmit}
              data-readdy-form
              id="newsletter-footer-form"
              className="relative"
            >
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t("form_email_placeholder")}
                required
                className="w-full bg-transparent border-b border-accent-500/40 py-2.5 pr-10 text-sm text-foreground-50 placeholder:text-accent-300/60 focus:outline-none focus:border-accent-300 transition-colors"
              />
              <button
                type="submit"
                disabled={submitStatus === "loading"}
                className="absolute right-0 top-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center text-accent-300 hover:text-foreground-50 transition-colors cursor-pointer disabled:opacity-50"
              >
                <i className="ri-send-plane-fill w-4 h-4 flex items-center justify-center"></i>
              </button>
            </form>
            {submitStatus === "success" && (
              <p className="mt-2 text-xs text-accent-300">Dziękujemy za zapisanie się!</p>
            )}
            {submitStatus === "error" && (
              <p className="mt-2 text-xs text-red-300">Wystąpił błąd. Spróbuj ponownie.</p>
            )}
            <p className="mt-3 text-xs text-accent-300/60">
              {t("form_subscribe_text")}
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-accent-200 uppercase tracking-wider mb-4">
              Linki
            </h4>
            <div className="space-y-3">
              <Link to="/" className="block text-sm text-accent-200/80 hover:text-foreground-50 transition-colors">
                {t("nav_home")}
              </Link>
              <Link to="/blog/kakobuy-spreadsheet-polska" className="block text-sm text-accent-200/80 hover:text-foreground-50 transition-colors">
                {t("nav_blog")}
              </Link>
              <a href="#" className="block text-sm text-accent-200/80 hover:text-foreground-50 transition-colors">
                {t("footer_privacy")}
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-accent-200 uppercase tracking-wider mb-4">
              Social Media
            </h4>
            <div className="space-y-3">
              <a href="#" target="_blank" rel="noopener nofollow" className="block text-sm text-accent-200/80 hover:text-foreground-50 transition-colors">
                Twitter / X
              </a>
              <a href="#" target="_blank" rel="noopener nofollow" className="block text-sm text-accent-200/80 hover:text-foreground-50 transition-colors">
                Instagram
              </a>
              <a href="#" target="_blank" rel="noopener nofollow" className="block text-sm text-accent-200/80 hover:text-foreground-50 transition-colors">
                Pinterest
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-accent-700/30">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-8">
          <div className="text-center">
            <span className="font-heading text-5xl md:text-7xl lg:text-8xl font-extrabold text-accent-800/30 tracking-tighter select-none">
              KAKOBUY
            </span>
          </div>
          <p className="text-center text-xs text-accent-300/50 mt-4">
            &copy; {new Date().getFullYear()} Kakobuy Courses. {t("footer_rights")}
          </p>
        </div>
      </div>
    </footer>
  );
}